import React from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import get from 'lodash.get';
import { useQuery } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';
import { Title, FlexWrapper, CheckIcon, Description, OutlineButton } from './styled-components';
import { medicationCheckmark as checkmark } from '../../../assets/icons';

interface PatientTodo {
  id: string;
  title: string;
  linkUrl: string;
  buttonText: string;
  description: string;
  completed: string;
  headingText: string;
  category: string;
}

const CONSENT_INFO = gql`
  query journeyConsent {
    patientTodos: allPatientTodos {
      id
      title: name
      linkUrl
      buttonText
      description
      completed
    }

    cyclePlan {
      id
      spermSource
    }
  }
`;

const Consent = () => {
  const history = useHistory();
  const { data, loading, error } = useQuery(CONSENT_INFO, { fetchPolicy: 'network-only' });
  if (loading || error || !data) {
    return null;
  }

  const patientTodos = get(data, 'patientTodos', []);
  const consentTodo = patientTodos.find(
    (todo: PatientTodo) => todo.linkUrl && todo.linkUrl.indexOf('consent') > 0
  );
  const spermSource = get(data, ['cyclePlan', 'spermSource']);
  const partnerSpermCopy =
    spermSource === 'Partner' ? ' Your partner will need to complete a consent too.' : '';

  if (!consentTodo) {
    return (
      <>
        <Title>Complete consent</Title>
        <Description>
          Please complete your consent form. It&apos;s critical that you complete this before your
          initial cycle visit.{partnerSpermCopy}
        </Description>
      </>
    );
  }

  return (
    <>
      <Title>
        {consentTodo.title}
        {consentTodo.completed && <CheckIcon src={checkmark} alt="check" />}
      </Title>
      <FlexWrapper>
        <div>
          <Description>
            {consentTodo.description}
            {partnerSpermCopy}
          </Description>
        </div>
        {!consentTodo.completed && (
          <Button onClick={() => history.push(consentTodo.linkUrl)}>
            {consentTodo.buttonText}
          </Button>
        )}
      </FlexWrapper>
    </>
  );
};

export default Consent;

const Button = styled(OutlineButton)`
  white-space: nowrap;
  height: min-content;
  width: min-content;
  margin-bottom: 20px;
`;
